import ActivationCodesCreate from "./ActivationCodesCreate";
import ActivationCodesEdit from "./ActivationCodesEdit";
import ActivationCodesList from "./ActivationCodesLists";

export default {
    list: ActivationCodesList,
    edit: ActivationCodesEdit,
    create: ActivationCodesCreate,
};
